import "../RaikoCustomChip.css"
import {css} from "@emotion/css";
import React from "react";
import {RaikoChipTypes} from "../RaikoChipTypes";
import PropTypes from "prop-types";
import {RaikoCustomSimpleChip} from "../raikoCustomSimpleChip/RaikoCustomSimpleChip";
import CloseIcon from "@material-ui/icons/Close";

export const RaikoCustomActionChip = ({id, title, onClick, type = RaikoChipTypes.primary, className}) => {
    return (
        <section className={`raikoCustomChipBaseContainer ${className}`}>
            <div
                className={`raikoCustomChipContainer ${type}`}
                onClick={(_) => {
                    onClick(id);
                }}>
                <CloseIcon
                    className={"customChipCloseIcon"}
                />
                <span className={"customChipTitle"}>
                {title}
             </span>
            </div>
        </section>
    )
}

RaikoCustomSimpleChip.propTypes = {
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    type: PropTypes.string
}